import axios from "axios";
import { jwtDecode } from "jwt-decode"; // Correct import without brackets
import endpoints from "../networks/endpoints";
import logClientError from "./logClientError";

export const tokenKey = "auth-tokenBola";

const httpRequest = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000,
  transitional: { clarifyTimeoutError: true }, // timeout -> ETIMEDOUT, beda dari request yang di-abort
});

const getBearerToken = () => {
  const bearerToken = JSON.parse(localStorage.getItem("user-data"));
  return bearerToken?.state?.accessToken;
};

const getToken = () => {
  return localStorage.getItem(tokenKey);
};

const setToken = (token) => {
  localStorage.setItem(tokenKey, token);
};

const isTokenExpired = () => {
  const token = getToken();
  if (!token) return true;

  const decoded = jwtDecode(token);
  return decoded.exp * 1000 < Date.now(); // Check expiration
};

const getRefreshedToken = async () => {
  const username = process.env.REACT_APP_LAPANGBOLA_UNAME;
  const password = process.env.REACT_APP_LAPANGBOLA_PWD;
  const res = axios
    .post(process.env.REACT_APP_API_URL + endpoints.getTokenLiveScore, {
      username,
      password,
    })
    .then((res) => {
      if (res?.status) {
        const tokenResult = res?.data?.data?.id_token;
        console.log({ tokenResult });
        return tokenResult;
      }
    });
  return res;
};

const refreshToken = async () => {
  const newToken = await getRefreshedToken();
  console.log({ newToken });
  setToken(newToken); // Adjust based on the response structure
};

const errorHandler = (error) => {
  return Promise.reject({
    statusCode: error.response.status,
    message: JSON.stringify(error.response.data),
  });
};

const requestHandler = async (request) => {
  // if (isTokenExpired()) {
  //   localStorage.removeItem(tokenKey);
  //   await refreshToken();
  // }
  if (request?.url?.includes("lapangbola")) {
    request.headers.authorization = `Bearer ${getToken()}`;
  } else {
    request.headers.authorization = getBearerToken();
  }

  return request;
};

httpRequest.interceptors.request.use(
  (request) => requestHandler(request),
  (error) => errorHandler(error)
);

// Yang dicatat cuma submit (non-GET). Token LapangBola di-POST tiap buka halaman,
// bukan form — kalau servernya down bakal ngabisin kuota tulis Firestore.
const isLoggable = (error) =>
  !error?.isAxiosError ||
  (error.config?.method !== "get" &&
    error.code !== "ERR_CANCELED" &&
    error.config?.url !== endpoints.getTokenLiveScore);

httpRequest.interceptors.response.use(
  (response) => response,
  (error) => {
    // Dicatat sebelum redirect 403: beacon tetap terkirim walau halaman langsung pindah.
    if (isLoggable(error)) logClientError(error, "http");
    if (error.response?.status === 403) {
      localStorage.clear();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default httpRequest;
